import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import { IntegrationsProviderWrapper } from '../../context';
import RequestIntegrationModal from '../../components/modals/RequestIntegrationModal';
import RequestsInboxPage from './RequestsInboxPage.jsx';

/**
 * Requests domain routes (CT-3898), mounted at /admin-studio/requests.
 *
 * A single index route renders RequestsInboxPage for both personas: admins get
 * the tenant-wide inbox, end users get the read-only "My requests" view. The
 * persona is driven by the demo toggle / RBAC seam (CT-4203) — no separate route
 * (matches the prototype's single `#/requests` branched by persona).
 * Shares IntegrationsProvider so "+ New request" opens the CT-4175 modal.
 */
const RequestsRoutes = () => (
  <IntegrationsProviderWrapper>
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <RequestsInboxPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
    <RequestIntegrationModal />
  </IntegrationsProviderWrapper>
);

export default RequestsRoutes;
